import { render, staticRenderFns } from "./GBankList.vue?vue&type=template&id=894b666a&lang=pug&"
import script from "./GBankList.vue?vue&type=script&lang=js&"
export * from "./GBankList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GBankList.vue"
export default component.exports